import { render, staticRenderFns } from "./GameChoir.vue?vue&type=template&id=089e6e80&scoped=true&"
import script from "./GameChoir.vue?vue&type=script&lang=js&"
export * from "./GameChoir.vue?vue&type=script&lang=js&"
import style0 from "./GameChoir.vue?vue&type=style&index=0&id=089e6e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089e6e80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
